var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.828 26.828"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 32870",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 7",
    d: "M1.414 1.414l24 24"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8",
    d: "M1.414 25.414l24-24"
  }))));
}

export default __webpack_public_path__ + "71d1993e1ce744719ca5bb5626276056.svg";
export { SvgClose as ReactComponent };